const Form029SC = {
    stepName: {
        statement: "重要提示",
        applicationTeacherInformation: "申请表格",
        confirmation: "确认页",
    },
    label1: {
        header: {
            headerOne: "填写申请表格须知",
        },
        contentOption: {
            t1: "申请人可亲身或以邮寄╱传真方式递交已填妥的申请表，教育局会以邮寄方式回覆申请人。收件地址如下：",
            t2: "申请人向教育局提交查核教师注册资料的申请前，须安排有关教师填写本表格第II部，证明已事先取得该教师的同意。申请人须确保已填妥本表格第I、II及IV部。",
            t3: "教育局可要求申请人及／或有关教师提供进一步资料，以核实本表格第 I、II及IV部所载的资料。",
        },
        serialOption: {
            t1: "(1)",
            t2: "(2)",
            t3: "(3)",
        },
        t1Option: {
            o1: "九龍协调道3号",
            o2: "工业贸易大楼2樓",
            o3: "教育局教师注册小组",
            o4: "电话：3467 8282&emsp;&emsp;传真：2520 0065",
            // o5: "传真：2520 0065",
            o6: "（办公时间：星期一至五上午八时三十分至下午一时及下午二时至六时星期六、日及公众假期休息）",
        },
        t7Option: {
            o7: "九龍协调道3号",
            o8: "工业贸易大楼2樓",
            o9: "教育局教师注册小组",
            o10: "（电话：3467 8282）",
        },

        statementOne: "本人已阅读、明白及同意上述条款及细则。",
        statementTwo: "本人理解申请人和教师需要拥有「智方便+」帐户才能处理申请。",
    },
    label: {
        ImportantNotesContent: {
            title: "个人资料收集声明",
            p_title: "收集个人资料的目的",
            p1_1: "你在本表格提供的个人资料，会供教育局用于以下一项或多项用途：",
            p1_a: "处理、核实及查证就发放教师注册资料的申请；",
            p1_b: "就上文(a)项所述申请的处理、核实及查证，将个人资料与政府相关政策局／部门资料库进行核对；",
            p1_c: "将个人资料与教育局资料库进行核对，以核实／更新教育局的记录；",
            p1_d: "培训及发展，包括发出计划／活动邀请、处理发还课程费用申请、 评审提名、奖项和奖学金，以及监察达标进度；",
            p1_e: "处理及审核拨款／补助／津贴申请、发放拨款／补助／津贴，以及审计；",
            p1_f: "编制统计资料、研究及政府刊物；以及",
            p1_g: "执行规则及规例[包括《教育条例》(香港法例第279章)及其附属法例(例如《教育规例》、《补助学校公积金规则》、《津贴学校公积金规则》)和《资助则例》 )]。",

            p2: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理申请。",

            p_title3: "可获转移资料者",
            p3_1: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
            p3_a: "政府其他政策局及部门，以用于上文第1段所述的用途；",
            p3_b: "与本表格相关的学校，以用于上文第1段所述的用途；",
            p3_c: "你曾就披露个人资料给予订明同意；以及；",
            p3_d: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",

            p_title4: "查阅个人资料",
            p4: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向教师注册小组提出(地址：九龙协调道3号工业贸易大楼2楼)。",
            // p5: "如欲查询有关本表格所蒐集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
        },
        header: {
            headerOne: "第I部（由申请发放教师注册资料的人士填写）",
            headerTwo: "第II部（由授权教育局发放教师注册资料的教师填写）",
            headerThree: "第III部（由教育局填写）",
            headerFour: "第IV部（由申请发放教师注册资料的人士填写）",
        },
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        sex: {
            male: "男",
            female: "女",
        },
        title: "先生／女士",
        englishName: "英文姓名",
        chineseName: "本人",
        chineseName2: "中文名字",
        IDNumber: "香港身份证号码",
        applicantContactNo: "申请人联络电话",
        nameOfApplicant: "申請人姓名",
        teacherRegistrationNo: "教员注册证号码",
        teachersContactNo: "教师联络电话",
        nameOfTeacher: "教师姓名",
        date: "日期",

        applicantName: "申请人姓名",
        applicantAddress: "申请人地址",
        emailAddress: "教师的电邮地址",
        tips: "申请人向教育局提交此申请表前，须安排有关教师填写本表格第II部，请填上相关教师的电邮地址。",
    },
    label2: {
        l1: "本人",
        l2: "(英文姓名︰",
        l3: ")，香港身份证号码︰",
        l4: "，申请发放第II部所述教师于第III部所列的教师注册资料。",
        l5: "本人谨此声明，本表格第I部所提供的资料均属真实及详尽。本人已阅读本申请表格全部内容，并明白「填写申请表格须知」。",
        l6: ")",
        l7: "，香港身份证号码︰",
    },
    label3: {
        l1: "本人",
        l2: "(英文姓名︰",
        l3: ")，教员注册证号码︰",
        l4: "，授权教育局向第I部所述人士发放下文第III部所列本人在《教育条例》(第279 章)下的教师注册资料。",
        l5: "本人谨此声明，本表格第II部所提供的资料均属真实及详尽。本人已阅读本申请表格全部内容，并明白「填写申请表格须知」。",
        l6: ")",
        l7: "，教员注册证号码︰",
    },
    errorMsg: {
        required: "此字段必填",
        requiredTrue: "请输入正确的字段 ",
        IDNumber: "请输入正确的身份证号码",
        enName: "请输入正确的英文名称",
        scName: "请输入正确的中文名称",
        email: "请输入正确的电邮地址",
        length: {
            note1: "长度不得超过20个字符",
            note2: "长度不得超过30个字符",
            note3: "长度不得超过50个字符",
            note4: "长度不得超过70个字符",
            note5: "长度不得超过100个字符",
            note6: "长度不得超过1000个字符",
            note7: "请输入长度不超过15位的字母／数字",
        },
        tel: {
            digit: "需要是8-15位",
            rule: "需要匹配电话号码规则",
            faxRule: "需要匹配传真号码规则",
        },
        date: {
            rule: "请输入有效日期",
            todayOrBefore: "请选择今天或之前",
            afterThisDate: "请在之后选择日期{{targetDate}}",
            age: "申请人在提交时至少年满18岁。",
        },
        tips: "请输入正确格式的内容 ",
        upload: "至少上传一个文件！",
        uploadMax: "最多上传一个文件！",
        uploadMax5: "最多上传五个文件！",
    },
    part3: {
        label1: "________ 先生／女士*︰",
        label2: "根据本局的记錄，以上教师的教师注册资料如下︰",
        option: {
            option1: "本局并无以上教师的教师注册记录。",
            option2: "以上教师现为检定教员。",
            option3: "以上教师现为准用教员。",
            option4:
                "以上教师由 ________ 至 ________ 期间为检定教员，但自 ________ 起已不再是检定教员。",
            option5:
                "以上教师由 ________ 至 ________ 期间为准用教员，但自 ________ 起已不再是准用教员。",
            option5b:
                "（如有关准用教员停止受雇于其准用教员许可证所指明的学校，该许可证须当作已经取消。）",
            option6:
                "由于有关教师没有填妥本表格第II部，故本局未能处理这项申请。",
        },
        label3: "如有查询，请致电3467 8282与教育局教师注册小组联络。",
    },
    submittedDialog: {
        text1: "你已成功送出表格。请注意表格尚未提交至教育局。表格正在等待教师填妥表格第 II 部。",
        text2: "相关电邮已发送至你的注册电邮。",
        multiLayerSubmitMsg: "你将会转到填写表格的页面。",
    },
};
export default Form029SC;
